module.exports = __webpack_public_path__ + "img/INDUSTRIA_03.09415a1e.jpg";